import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

export const adminValidateTeacherPayout = createAsyncThunk<void, { payoutId: string }, { extra: Partial<Dependencies> }>(
  "teacherPayouts/adminValidateTeacherPayout",
  async ({ payoutId }, { extra: { adminRepository } }) => {
    await adminRepository!.validateTeacherPayout({ payoutId });
  },
);

export const resetTeacherPayoutValidation = createAction("teacherPayouts/resetTeacherPayoutValidation");
